var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpenseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.77596 4.64392V5.69467M8.77596 11.9992V13.0499M16.2 9.00005C16.2 12.9765 12.9765 16.2 9.00005 16.2C5.0236 16.2 1.80005 12.9765 1.80005 9.00005C1.80005 5.0236 5.0236 1.80005 9.00005 1.80005C12.9765 1.80005 16.2 5.0236 16.2 9.00005ZM7.19984 5.69467H9.82671C10.2447 5.69467 10.6456 5.86073 10.9412 6.15631C11.2368 6.45189 11.4028 6.85278 11.4028 7.2708V7.34593C11.4028 7.74402 11.2447 8.1258 10.9632 8.40729C10.6817 8.68878 10.2999 8.84692 9.90184 8.84692H7.19984H9.82671C10.2447 8.84692 10.6456 9.01298 10.9412 9.30856C11.2368 9.60414 11.4028 10.005 11.4028 10.423V10.4982C11.4028 10.8963 11.2447 11.2781 10.9632 11.5595C10.6817 11.841 10.2999 11.9992 9.90184 11.9992H7.19984V5.69467Z",
    stroke: "#667085",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpenseIcon);
export default __webpack_public_path__ + "static/media/expenseIcon.3f5dc74eb54f25cbdd084550c1f5fd95.svg";
export { ForwardRef as ReactComponent };